import { useEffect, useCallback } from "react";
import Alert, { AlertType } from "../../../components/Alert";
import UserInputs from "../../../components/UserInputs";
import PermissionsChecklist from "../../Permissions/PermissionsChecklist"

const MemberDetails = ({ userFirstName, userLastName, userEmail, userPermissions, initialData, onChangeInput, setCanSubmit, title, availablePermissions, disableTogglingManageAdminUsersPermission }) => {

	const handlePermissionsChange = useCallback((nextAssigned) => {
		onChangeInput({
			userPermissions: {
				value: nextAssigned,
				validation: userPermissions?.validation ?? 0
			}
		});
	}, [onChangeInput, userPermissions?.validation]);

	const samePermissionNames = (a, b) => {
		const setA = new Set((a ?? []).map(p => p?.Name));
		const setB = new Set((b ?? []).map(p => p?.Name));
		if (setA.size !== setB.size) {
			return false;
		}
		for (const n of setA) {
			if (!setB.has(n)) {
				return false;
			}
		}
		return true;
	};

	useEffect(() => {
		const hasRequired =
			userFirstName.value.trim().length > 0 &&
			userLastName.value.trim().length > 0 &&
			userEmail.value.trim().length > 0;

		if (!hasRequired) {
			setCanSubmit(false);
			return;
		}

		const namesChanged = !samePermissionNames(
			initialData?.userPermissions?.value,
			userPermissions?.value
		);

		const fieldsChanged =
			initialData?.userFirstName?.value !== userFirstName.value ||
			initialData?.userLastName?.value !== userLastName.value ||
			initialData?.userEmail?.value !== userEmail.value ||
			namesChanged;

		setCanSubmit(hasRequired && fieldsChanged);
	}, [initialData, userFirstName.value, userLastName.value, userEmail.value, userPermissions?.value, setCanSubmit]);

	return (
		<>
			<div>
				{(!title.startsWith("Edit")) && <Alert type={AlertType.Warning}>
					Warning: This will create a new team member who has the same level of access as you for this portal. They will be able to see the same details and
					perform the same actions as yourself. Please make sure you are entering the correct details and that the recipient is expecting this email.
				</Alert>}
				<UserInputs
					nameLabel="Team Member Name"
					firstName={userFirstName}
					lastName={userLastName}
					emailLabel="Team Member Email"
					email={userEmail}
					onChangeInput={onChangeInput}
				/>
			</div>
			<div>
				<PermissionsChecklist readOnly={false} allAvailablePermissions={availablePermissions} assignedPermissions={userPermissions.value} onChange={handlePermissionsChange} disableTogglingManageAdminUsersPermission={disableTogglingManageAdminUsersPermission}></PermissionsChecklist>
			</div>
		</>
	);
};

export default MemberDetails;